<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
html,
body {
  margin: 0;
}
* {
  margin: 0;
  padding: 0;
}
</style>
